import { render, staticRenderFns } from "./DestinationInsiderTipSummaryTab.vue?vue&type=template&id=2164f30c&scoped=true&"
import script from "./DestinationInsiderTipSummaryTab.vue?vue&type=script&lang=js&"
export * from "./DestinationInsiderTipSummaryTab.vue?vue&type=script&lang=js&"
import style0 from "./DestinationInsiderTipSummaryTab.vue?vue&type=style&index=0&id=2164f30c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164f30c",
  null
  
)

export default component.exports